'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('plantype', {
        url: '/plantype',
        template: '<plantype></plantype>'
    });
}



// WEBPACK FOOTER //
// ./client/app/plantype/plantype.routes.js